export const validateVehicle = (vehicle) => {
  const errors = {};
  if (!vehicle.chapa) errors.chapa = 'La chapa es requerida';
  if (!vehicle.marca) errors.marca = 'La marca es requerida';
  if (!vehicle.cliente_dni) errors.cliente_dni = 'El cliente es requerido';
  return errors;
}; 